import type { CustomCompType } from '@neo/blocks/forms/types'
import { cn } from '@neo/lib/utils'
import { Card } from '@neo/primitives/card'
import { FileText, GlobeIcon, Grid2x2Plus } from 'lucide-react'
import { resetFieldMeta } from '@neo/blocks/forms/form-util'
import { KBDocumentSource, type NewKBFormValues } from '../../types'

interface SourceTypeCardProps {
  icon: React.ReactNode
  title: string
  isSelected: boolean
  onClick: () => void
}

const SourceTypeCard = ({ icon, title, isSelected, onClick }: SourceTypeCardProps) => (
  <Card
    className={cn(
      'flex items-center gap-2 p-4 cursor-pointer border-[1.5px] hover:border-primary transition-colors w-[195px]',
      isSelected ? 'border-primary text-p-600' : 'border-border text-secondary text-p-500',
    )}
    variant="noShadow"
    onClick={onClick}
    data-testid={`button-source-type-${title.toLowerCase()}`}
  >
    {icon}
    <span>{title}</span>
  </Card>
)

export const TypeSelector: CustomCompType<NewKBFormValues> = ({ onChange, value, form }) => (
  <div className="flex flex-col gap-2 mt-6">
    <div className="text-s-500">Data source</div>
    <div className="flex gap-4">
      <SourceTypeCard
        icon={<FileText className="size-5" />}
        title="Import from file"
        isSelected={value === KBDocumentSource.FILE}
        onClick={() => {
          onChange(KBDocumentSource.FILE)
          resetFieldMeta(form, 'files')
        }}
      />
      <SourceTypeCard
        icon={<GlobeIcon className="size-5" />}
        title="Sync from website"
        isSelected={value === KBDocumentSource.URL}
        onClick={() => {
          onChange(KBDocumentSource.URL)
          resetFieldMeta(form, 'links')
        }}
      />
      <SourceTypeCard
        icon={<Grid2x2Plus className="size-5" />}
        title="Sync from apps"
        isSelected={value === KBDocumentSource.APP}
        onClick={() => {
          onChange(KBDocumentSource.APP)
          resetFieldMeta(form, 'app_source')
        }}
      />
    </div>
  </div>
)
